import { render, staticRenderFns } from "./StdDialog.vue?vue&type=template&id=278832f8&"
import script from "./StdDialog.vue?vue&type=script&lang=js&"
export * from "./StdDialog.vue?vue&type=script&lang=js&"
import style0 from "./StdDialog.vue?vue&type=style&index=0&id=278832f8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports